import React, { useState, useEffect } from 'react';
import { Plus, Play, MoreVertical, Lock, X, Music, PencilIcon, ShareIcon, TrashIcon, FileText, Mail, Trash } from 'lucide-react';
import Sidebar from '../../Sidebar/Sidebar';
import Navbar from '../../Navbars/UserNavbar';
import { DashboardApi } from '../../../apis/DashboardApi';
import { AxiosResponse } from 'axios';
import { IoInformation } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';
import { convertUTCDateToLocalDate } from '../../../functions';
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from 'react-redux';

interface Tab {
    id: string;
    label: string;
}

interface Media {
    id: number;
    file_name: string;
    file_type: string;
    temporaryUrl: string;
    is_legacy: number;
    created_at?: string;
    file_size?: string;
    recipients?: any;
    recipientTemporaryUrl?: any;
    handleDelete?: () => void;
    handleRename?: () => void;
    handleShare?: () => void;
}

interface MediaResponse {
    status: string;
    data: {
        files: {
            data: Media[];
        };
        collections: any[];
    };
}

const formatSize = (bytes: any): any => {
    if (bytes < 1024) return `${bytes}MB`; // If less than 1GB, show in MB
    else if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)}GB`; // If less than 1TB, show in GB
    else return `${(bytes / (1024 * 1024)).toFixed(2)}TB`; // Otherwise, show in TB
};

interface MediaModalProps {
    media: any;
    onClose: () => void;
}

const MediaModal: React.FC<MediaModalProps> = ({ media, onClose }) => {
    if (!media) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
            <div className="relative bg-white rounded-lg max-w-xl w-full mx-4" onClick={e => e.stopPropagation()}>
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 z-10"
                >
                    <X className="w-6 h-6" />
                </button>

                <div className="p-4">
                    {media.media.type === 'video' && (
                        <div className="aspect-video p-2 pt-5">
                            <video
                                src={media.media.temporaryUrl}
                                controls
                                className="w-full h-full rounded-lg"
                            >
                                Your browser does not support video playback.
                            </video>
                        </div>
                    )}

                    {media.media.type === 'image' && (
                        <div className="relative max-h-[80vh] overflow-hidden p-2 pt-5">
                            <img
                                src={media.media.temporaryUrl}
                                alt={media.media.name}
                                className="w-full h-[400px] object-contain rounded-lg"
                            />
                        </div>
                    )}

                    {media.media.type === 'audio' && (
                        <div className="p-2 pt-5">
                            <audio
                                src={media.media.temporaryUrl}
                                controls
                                className="w-full"
                            >
                                Your browser does not support audio playback.
                            </audio>
                        </div>
                    )}

                    {media.media.type === 'document' && (
                        <div className="p-2 pt-5">
                            <iframe
                                src={`https://docs.google.com/viewer?url=${encodeURIComponent(media.media.temporaryUrl)}&embedded=true`}
                                className="w-full max-h-[600px] border rounded-md"
                                frameBorder="0"
                            >
                                Your browser does not support viewing documents.
                            </iframe>
                        </div>
                    )}

                    {/* {media.file_type === 'document' && (
                        <div className="p-8 ">
                            <iframe
                                src={media.temporaryUrl}
                                className="w-full h-[100px] border rounded-md"
                            // frameBorder="0"
                            >
                                Your browser does not support viewing documents.
                            </iframe>
                        </div>
                    )} */}


                    <div className="mt-4 flex justify-between ">
                        <div className="text-[12px] leading-7 font-medium">
                            <h3 >File Name: {media.media.name}</h3>
                            <h3 >Shared By: {media.shared_by.email}</h3>
                            <h3 >Shared Date: {convertUTCDateToLocalDate(media?.shared_at)}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SharedMedia = () => {
    const [media, setMedia] = useState<any>([]);
    const [mediaSize, setMediaSize] = useState<any>('');
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('my-media');
    const [activeFilter, setActiveFilter] = useState('all');
    const userLoginData = useSelector((state: any) => state.data.login.value);
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);

    const mainTabs: Tab[] = [
        { id: 'my-media', label: 'Shared Media' },
        // { id: 'schedule-media', label: 'Schedule Media' },
        // { id: 'legacy', label: 'Legacy' }
    ];

    const filters: Tab[] = [
        { id: 'all', label: 'All' },
        { id: 'video', label: 'Video' },
        { id: 'image', label: 'Image' },
        { id: 'audio', label: 'Audio' },
        { id: 'document', label: 'Document' }
    ];


    React.useEffect(() => {
        DashboardApi.getSharedWithMe().then(
            (response: AxiosResponse<any>) => {
                if (response?.data) {
                    console?.log(response?.data)
                    setMedia(response?.data?.data)
                    setLoading(false)
                }
            }
        )

    }, []);



    const [selectedMedia, setSelectedMedia] = useState<any | null>(null);

    const handleMediaClick = (media: any) => {
        setSelectedMedia(media);

    };



    const getMediaCard = (item: any) => {
        const commonClasses = "relative rounded-lg overflow-hidden bg-gray-100 h-[300px] w-full";
        const bottomBarClasses = "absolute bottom-0 left-0 right-0 flex justify-between items-center p-3 bg-gradient-to-t from-black/50 to-transparent";

        switch (item.media.type) {
            case 'video':
                return (
                    <div className={commonClasses}>
                        <video src={item.media.temporaryUrl} className="w-full h-full object-cover" />
                        <div onClick={() => handleMediaClick(item)} className="absolute inset-0 flex items-center justify-center">
                            <button className="bg-black/50 rounded-full p-3 hover:bg-black/70">
                                <Play className="w-6 h-6 text-white" />
                            </button>
                        </div>
                       
                        <div className={bottomBarClasses}>
                            <span className="text-white text-sm truncate">{item.media.name}</span>
                        </div>
                    </div>
                );

            case 'image':
                return (
                    <div className={commonClasses}>
                        <img onClick={() => handleMediaClick(item)} src={item.media.temporaryUrl} alt={item.media.name} className="w-full h-full object-cover" />
                       
                        <div className={bottomBarClasses}>
                            <span className="text-white text-sm truncate">{item.media.name}</span>
                        </div>
                    </div>
                );

            case 'audio':
                return (
                    <div className={`${commonClasses} bg-white border flex flex-col justify-center items-center`}>
                        <Music className="w-16 h-16 text-gray-400 mb-4" onClick={() => handleMediaClick(item)} />
                        <div className="w-3/4 h-2 bg-gray-200 rounded-full" />
                       
                        <div className={bottomBarClasses}>
                            <span className="text-white text-sm truncate">{item.media.name}</span>
                           
                        </div>
                    </div>
                );

            case 'document':
                return (
                    <div

                        className={`${commonClasses} bg-white border flex flex-col justify-center items-center`}
                    >
                        <FileText onClick={() => handleMediaClick(item)} className="w-16 h-16 text-gray-400 mb-4" />
                        <span className="text-sm text-gray-500 truncate">{item.media.name}</span>
                        <div className={bottomBarClasses}>
                            <span className="text-white text-sm truncate">{item.media.name}</span>

                           
                        </div>
                    </div>
                );


            default:
                return null;
        }
    };


    return (
        <div className="min-h-screen bg-white">
            <div className="flex flex-col md:flex-row">
                <Sidebar />
                <main className="flex-1 p-6 relative md:ml-64">
                    <Navbar />
                    <div className="p-4 md:p-6">
                        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 space-y-4 md:space-y-0">
                            <div className="flex space-x-6 overflow-x-auto pb-2 md:pb-0">
                                {mainTabs.map((tab) => (
                                    <button
                                        key={tab.id}
                                        // onClick={() => handleMediaClick(tab)}
                                        className={`whitespace-nowrap pb-2 font-medium text-sm md:text-base border-b-2 cursor-pointer transition-colors
                      ${activeTab === tab.id
                                                ? 'text-orange-500 border-orange-500'
                                                : 'text-gray-600 border-transparent hover:text-orange-500'}`}
                                    >
                                        {tab.label}
                                    </button>
                                ))}
                            </div>


                            {/* <NavLink to={mediaSize < userLoginData?.data?.user_data?.max_upload_limit_mb ? '/add-media' : '/upgrade'}>
                                <button className="flex items-center gap-2 px-4 py-2 text-orange-500 border border-orange-500 rounded-lg hover:bg-orange-50">
                                    <Plus className="w-5 h-5" />
                                    <span>{mediaSize < userLoginData?.data?.user_data?.max_upload_limit_mb ? 'Add media' : 'Upgrade'} </span>
                                </button>
                            </NavLink> */}

                        </div>

                        <div className="flex flex-wrap gap-2 mb-8">
                            {filters.map((filter) => (
                                <button
                                    key={filter.id}
                                    onClick={() => setActiveFilter(filter.id)}
                                    className={`px-6 py-2 rounded-full text-sm transition-colors
                    ${activeFilter === filter.id
                                            ? 'bg-blue-700 text-white'
                                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
                                >
                                    {filter.label}
                                </button>
                            ))}
                        </div>

                        {loading ? (
                            <div>Loading...</div>
                        ) : media.length === 0 ? (
                            <div className="flex flex-col items-center justify-center py-16 px-4 border-2 border-dashed rounded-lg">
                                <p className="text-gray-500 text-center mb-4">No Shared media files yet</p>
                                {/* <NavLink to={'/add-media'} className="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600">
                                    Upload Media
                                </NavLink> */}
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                {media
                                    .filter((item:any) => activeFilter === 'all' || item?.media?.type === activeFilter)
                                    .map((item:any) => (
                                        <div key={item?.media?.id}
                                            className="cursor-pointer ">{getMediaCard(item)}</div>
                                    ))}
                            </div>
                        )}
                    </div>
                </main>

                {selectedMedia && (
                    <div className='t-20'>
                        <MediaModal
                            media={selectedMedia}
                            onClose={() => setSelectedMedia(null)}
                        />
                    </div>
                )}
            </div>

            


            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover />
        </div>
    );
};

export default SharedMedia;